/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AvailableInputs */

const en_available = /** @type {(inputs: AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available`)
};

const id_available = /** @type {(inputs: AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersedia`)
};

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const es_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const fr_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const de_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const ja_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const zh_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const ar_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const it_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const ru_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const pt_available = en_available;

/** @type {(inputs: AvailableInputs) => LocalizedString} */
const ko_available = en_available;

/**
* | output |
* | --- |
* | "Available" |
*
* @param {AvailableInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const available = /** @type {((inputs?: AvailableInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AvailableInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_available(inputs)
	if (locale === "es") return es_available(inputs)
	if (locale === "fr") return fr_available(inputs)
	if (locale === "de") return de_available(inputs)
	if (locale === "ja") return ja_available(inputs)
	if (locale === "zh") return zh_available(inputs)
	if (locale === "ar") return ar_available(inputs)
	if (locale === "id") return id_available(inputs)
	if (locale === "it") return it_available(inputs)
	if (locale === "ru") return ru_available(inputs)
	if (locale === "pt") return pt_available(inputs)
	return ko_available(inputs)
});